import { getBaseUrl } from "@root/store/selectors/features";
import { HttpService } from "../http";
import { store } from "@root/store";

export class ProjectsService extends HttpService {
  // Projects API calls
  baseUrl = getBaseUrl(store.getState());
  fetchProjects = async (payload: any): Promise<any> => {
    const baseUrl = `${this.baseUrl}/api/projects`;
    try {
      // const apiResponse = await this.get(baseUrl, payload);
      // return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  fetchProject = async (id: number): Promise<any> => {
    const baseUrl = `${this.baseUrl}/api/projects/${id}`;
    try {
      const apiResponse = await this.get(baseUrl);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  addProject = async (payload: any): Promise<any> => {
    const baseUrl = `${this.baseUrl}/api/projects`;
    try {
      const apiResponse = await this.post(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  updateProject = async (id: number, payload: any): Promise<any> => {
    const baseUrl = `${this.baseUrl}/api/projects/${id}`;
    try {
      const apiResponse = await this.patch(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  deleteProject = async (id: number): Promise<any> => {
    const baseUrl = `${this.baseUrl}/api/projects/${id}`;
    try {
      const apiResponse = await this.delete(baseUrl);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  // Folders API calls
  fetchFolders = async (payload: any): Promise<any> => {
    const baseUrl = `${this.baseUrl}/api/folders`;
    try {
      const apiResponse = await this.get(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  fetchFolder = async (id: number): Promise<any> => {
    const baseUrl = `${this.baseUrl}/api/folders/${id}`;
    try {
      const apiResponse = await this.get(baseUrl);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  addFolder = async (payload: any): Promise<any> => {
    const baseUrl = `${this.baseUrl}/api/folders`;
    try {
      const apiResponse = await this.post(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  updateFolder = async (id: number, payload: any): Promise<any> => {
    const baseUrl = `${this.baseUrl}/api/folders/${id}`;
    try {
      const apiResponse = await this.patch(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  deleteFolder = async (id: number): Promise<any> => {
    const baseUrl = `${this.baseUrl}/api/folders/${id}`;
    try {
      const apiResponse = await this.delete(baseUrl);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  // Documents API calls
  fetchDocuments = async (payload: any): Promise<any> => {
    const baseUrl = `${this.baseUrl}/api/documents`;
    try {
      // const apiResponse = await this.get(baseUrl, payload);
      // return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  fetchDocument = async (id: number): Promise<any> => {
    const baseUrl = `${this.baseUrl}/api/documents/${id}`;
    try {
      const apiResponse = await this.get(baseUrl);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  addDocument = async (payload: any): Promise<any> => {
    const baseUrl = `${this.baseUrl}/api/documents`;
    try {
      const apiResponse = await this.post(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  updateDocument = async (id: number, payload: any): Promise<any> => {
    const baseUrl = `${this.baseUrl}/api/documents/${id}`;
    try {
      const apiResponse = await this.put(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  deleteDocument = async (id: number): Promise<any> => {
    const baseUrl = `${this.baseUrl}/api/documents/${id}`;
    try {
      const apiResponse = await this.delete(baseUrl);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };
}
